import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, withCredentials: true });
http.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("efp-token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

async function downloadFile(path, filename) {
  const r = await http.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([r.data]));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

const stamp = () => new Date().toISOString().slice(0, 10).replace(/-/g, "");

let currentSettore = "sportivo";

export const api = {
  setSettore: (s) => { currentSettore = s || "sportivo"; },
  getSettore: () => currentSettore,
  listSsd: () => http.get(`/ssd?settore=${currentSettore}`).then((r) => r.data),
  createSsd: (data) => http.post("/ssd", { settore: currentSettore, ...data }).then((r) => r.data),
  updateSsd: (id, data) => http.put(`/ssd/${id}`, data).then((r) => r.data),
  deleteSsd: (id) => http.delete(`/ssd/${id}`).then((r) => r.data),
  listCollab: () => http.get(`/collaboratori?settore=${currentSettore}`).then((r) => r.data),
  createCollab: (data) => http.post("/collaboratori", { settore: currentSettore, ...data }).then((r) => r.data),
  updateCollab: (id, data) => http.put(`/collaboratori/${id}`, data).then((r) => r.data),
  deleteCollab: (id) => http.delete(`/collaboratori/${id}`).then((r) => r.data),
  resetData: () => http.post("/data/reset").then((r) => r.data),
  calLink: () => http.get("/calendario/link").then((r) => r.data),
  calRigenera: () => http.post("/calendario/link/rigenera").then((r) => r.data),
  getSettingsOf: (s) => http.get(`/settings?settore=${s}`).then((r) => r.data),
  updateSettingsOf: (s, data) => http.put(`/settings?settore=${s}`, data).then((r) => r.data),
  inviaCalendario: (id) => http.post(`/collaboratori/${id}/invia-calendario`).then((r) => r.data),
  inviaCalendarioTutti: () => http.post(`/collaboratori/invia-calendario?settore=${currentSettore}`).then((r) => r.data),
  listProgetti: () => http.get(`/progetti?settore=${currentSettore}`).then((r) => r.data),
  createProgetto: (data) => http.post("/progetti", { settore: currentSettore, ...data }).then((r) => r.data),
  updateProgetto: (id, data) => http.put(`/progetti/${id}`, data).then((r) => r.data),
  deleteProgetto: (id) => http.delete(`/progetti/${id}`).then((r) => r.data),
  getSettings: () => http.get(`/settings?settore=${currentSettore}`).then((r) => r.data),
  updateSettings: (data) => http.put(`/settings?settore=${currentSettore}`, data).then((r) => r.data),
  seed: () => http.post("/seed").then((r) => r.data),
  exportCompensi: () => downloadFile("/export/compensi", `compensi_efferre_${stamp()}.xlsx`),
  exportClienti: (params = {}) => {
    const q = new URLSearchParams(Object.entries(params).filter(([, v]) => v)).toString();
    return downloadFile(`/export/clienti${q ? "?" + q : ""}`, `clienti_efferre_${stamp()}.xlsx`);
  },
  exportClientiPdf: (params = {}) => {
    const q = new URLSearchParams(Object.entries(params).filter(([, v]) => v)).toString();
    return downloadFile(`/export/clienti/pdf${q ? "?" + q : ""}`, `clienti_efferre_${stamp()}.pdf`);
  },
  listCompensiStorico: () => http.get("/compensi/storico").then((r) => r.data),
  listPortfolio: () => http.get(`/portfolio?settore=${currentSettore}`).then((r) => r.data),
  createPortfolio: (data) => http.post("/portfolio", { settore: currentSettore, ...data }).then((r) => r.data),
  updatePortfolio: (id, data) => http.put(`/portfolio/${id}`, data).then((r) => r.data),
  deletePortfolio: (id) => http.delete(`/portfolio/${id}`).then((r) => r.data),
  uploadPortfolioDoc: (id, file) => {
    const fd = new FormData();
    fd.append("file", file);
    return http.post(`/portfolio/${id}/documenti`, fd).then((r) => r.data);
  },
  downloadPortfolioDoc: (id, d) => downloadFile(`/portfolio/${id}/documenti/${d.id}`, d.nome),
  deletePortfolioDoc: (id, did) => http.delete(`/portfolio/${id}/documenti/${did}`).then((r) => r.data),
  ssdToPortfolio: (id) => http.post(`/ssd/${id}/to-portfolio`).then((r) => r.data),
  listAgenda: (portfolioId) => http.get(portfolioId ? `/agenda?portfolio_id=${portfolioId}` : `/agenda?settore=${currentSettore}`).then((r) => r.data),
  createAgenda: (data) => http.post("/agenda", { settore: currentSettore, ...data }).then((r) => r.data),
  updateAgenda: (id, data) => http.put(`/agenda/${id}`, data).then((r) => r.data),
  deleteAgenda: (id) => http.delete(`/agenda/${id}`).then((r) => r.data),
  listAttivita: () => http.get(`/attivita?settore=${currentSettore}`).then((r) => r.data),
  createAttivita: (data) => http.post("/attivita", { settore: currentSettore, ...data }).then((r) => r.data),
  updateAttivita: (id, data) => http.put(`/attivita/${id}`, data).then((r) => r.data),
  deleteAttivita: (id) => http.delete(`/attivita/${id}`).then((r) => r.data),
  inviaInvito: (id) => http.post(`/attivita/${id}/invito`).then((r) => r.data),
  inviaInvitoExperience: (id) => http.post(`/progetti/${id}/invito`).then((r) => r.data),
  syncInviti: () => http.post("/inviti/sync").then((r) => r.data),
  emailStatus: () => http.get("/email/status").then((r) => r.data),
  controlloVerify: (pin) => http.post("/controllo/verify", { pin }).then((r) => r.data),
  listMovimenti: () => http.get(`/movimenti?settore=${currentSettore}`).then((r) => r.data),
  createMovimento: (data) => http.post("/movimenti", { settore: currentSettore, ...data }).then((r) => r.data),
  updateMovimento: (id, data) => http.put(`/movimenti/${id}`, data).then((r) => r.data),
  deleteMovimento: (id) => http.delete(`/movimenti/${id}`).then((r) => r.data),
  listMateriali: () => http.get(`/materiali?settore=${currentSettore}`).then((r) => r.data),
  uploadMateriale: (formData, onProgress) => {
    formData.append("settore", currentSettore);
    return http.post("/materiali", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: onProgress,
    }).then((r) => r.data);
  },
  deleteMateriale: (id) => http.delete(`/materiali/${id}`).then((r) => r.data),
  shareMateriale: (id, giorni) => http.post(`/materiali/${id}/share`, { giorni }).then((r) => r.data),
  revokeShare: (id) => http.delete(`/materiali/${id}/share`).then((r) => r.data),
  materialeFileUrl: (id, download) => `${API}/materiali/${id}/file${download ? "?download=1" : ""}`,
  materialeShareUrl: (id, token) => `${API}/materiali/${id}/file?token=${token}`,
  login: (email, password) => http.post("/auth/login", { email, password }).then((r) => r.data),
  register: (data) => http.post("/auth/register", data).then((r) => r.data),
  me: () => http.get("/auth/me").then((r) => r.data),
  logout: () => http.post("/auth/logout").then((r) => r.data),
  updateCredentials: (data) => http.put("/auth/credentials", data).then((r) => r.data),
  listListe: () => http.get(`/liste?settore=${currentSettore}`).then((r) => r.data),
  importLista: (formData, onProgress) => {
    formData.append("settore", currentSettore);
    return http.post("/liste/import", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: onProgress,
    }).then((r) => r.data);
  },
  updateLista: (id, data) => http.put(`/liste/${id}`, data).then((r) => r.data),
  deleteLista: (id) => http.delete(`/liste/${id}`).then((r) => r.data),
  listContatti: (id) => http.get(`/liste/${id}/contatti`).then((r) => r.data),
  addContatto: (id, data) => http.post(`/liste/${id}/contatti`, data).then((r) => r.data),
  updateContatto: (id, data) => http.put(`/contatti/${id}`, data).then((r) => r.data),
  deleteContatto: (id) => http.delete(`/contatti/${id}`).then((r) => r.data),
  spostaPipeline: (contatto_ids, collaboratore_id) => http.post("/liste/sposta", { contatto_ids, collaboratore_id }).then((r) => r.data),
  exportLista: (id, nome) => downloadFile(`/liste/${id}/export`, `lista_${(nome || "contatti").replace(/[^a-z0-9]/gi, "_")}.xlsx`),
  exportListaPdf: (id, nome) => downloadFile(`/liste/${id}/export/pdf`, `lista_${(nome || "contatti").replace(/[^a-z0-9]/gi, "_")}.pdf`),
  downloadTemplateContatti: () => downloadFile(`/liste/template?settore=${currentSettore}`, currentSettore === "ritrattistica" ? "modello_contatti_ritrattistica.xlsx" : "modello_contatti_efferre.xlsx"),
  exportPreventivo: (id, nome) => downloadFile(`/ssd/${id}/preventivo/pdf`, `preventivo_${(nome || "ssd").replace(/[^a-z0-9]/gi, "_")}.pdf`),
};